import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { routes } from './Routes';
import { adminRoutes } from './AdminRoutes';
import AppLayout from '../Layout/Layout';
import PrivateRoute from './PrivateRoute';

const LayoutRoutes = () => (
  <Routes>
    <Route element={<PrivateRoute />}>
      <Route element={<AppLayout />}>
        {routes.map(({ path, Component }, i) => (
          <Route key={i} path={path} element={Component} />
        ))}
      </Route>
    </Route>
    <Route element={<PrivateRoute adminOnly />}>
      <Route element={<AppLayout />}>
        {adminRoutes.map(({ path, Component }, i) => (
          <Route key={i} path={path} element={Component} />
        ))}
      </Route>
    </Route>
    <Route path='/' element={<Navigate to='/dashboard' replace />} />
  </Routes>
);

export default LayoutRoutes;